enum Role {
    PARTNER_CREATOR = 'PartnerCreator',
    PARTNER_OPERATOR = 'PartnerOperator',
    GLS_ADMIN = 'GLSAdmin',
    CUSTOMER_FRONTEND = 'CustomerFrontend',
    PARTNER_CUSTOMER_SERVICE = 'PartnerCustomerService',
    CREATE_SHIPMENT = 'CreateShipment',
    SHIPMENT_OVERVIEW = 'ShipmentOverview',
    CREATE_TRANSPORTATION_LIST = 'CreateTransportationList',
    TRANSPORTATION_OVERVIEW = 'TransportationOverview',
    PARCEL_TRACKING = 'ParcelTracking',
    PARCEL_DATA = 'ParcelData',
    REPRINT_LABEL = 'ReprintLabel',
    LOADING_LIST_ASSIGNMENT = 'LoadingListAssignment',
    AUTO_PARCELS_ASSIGNMENT = 'AutoParcelsAssignment',
    FORWARD_PARCEL = 'ForwardParcel',
    REVERT_PARCEL = 'RevertParcel',
    INITIAL_PARCEL = 'InitialParcel'
}

export default Role;
